
import { useEffect, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { SendDocumentDataType } from "@/formTypes/SendDocumentDataType";
import { OpenSendDocumentPubSub, OpenSendDocumentPubSubPayload } from "@utils/pubsubs/PubSub";
import SendToEmailForm, { EmailProps } from "@components/forms/SendToEmailForm";

type SendDocumentToEmailOffCanvasProps = {
    // onTaxChanged: (taxChange?: SendDocumentDataType) => void
} & DefaultOffCanvasProps

const SendDocumentToEmailOffCanvas = (props: SendDocumentToEmailOffCanvasProps) => {
    const { btnColor = "primary", className, title } = props;
    const [defaultData, setDefaultData] = useState<SendDocumentDataType>({} as SendDocumentDataType);
    const [isOpen, setOpen] = useState(false);
    const [sourceURL, setSourceURL] = useState("");
    const [emailProps, setEmailProps] = useState<EmailProps>({} as EmailProps);

    useEffect(() => {
        const unsubscribe = OpenSendDocumentPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenSendDocumentPubSubPayload) => {
        const { openOffCanvas = false, sourceURL, emails, emailProps } = payload;
        setOpen(openOffCanvas);
        setSourceURL(sourceURL || "");
        if (emailProps) {
            setEmailProps(emailProps)
        }
        if (emails) {
            setDefaultData({ emails });
        }
    }


    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    {title}
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <p>
                            Por favor ingrese la dirección de correo electrónico a la cual será enviada este Documento
                        </p>
                        <SendToEmailForm
                            emailProps={emailProps}
                            sourceURL={sourceURL}
                            onSendForm={() => OpenSendDocumentPubSub.publish({
                                openOffCanvas: false
                            })}
                            defaultData={defaultData}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default SendDocumentToEmailOffCanvas;
